import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./staffPage.css";
import CustomTable from "../../components/styledComponent/styledTable";
import { StyledButton } from "../../components/styledComponent/styledElements";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { AiOutlinePlusSquare } from "react-icons/ai";
import TableActions from "../../components/tableAction/tableActions";
import {
  createStaff,
  disableStaff,
  enableStaff,
  listAllStaff,
} from "../../server/staffServices";
import StaffCreationModal from "./staffCreationModal";
import { ShowNotification } from "../../components/notification/notification";
import { DisableEnableModal } from "../../components/styledComponent/deleteModal";
import { Tag } from "antd";
import { useAppContext } from "../../contexts/appContext";

function StaffPage() {
  const formRef = useRef(null);
  const navigate = useNavigate();
  const { startLoading, stopLoading, user } = useAppContext();

  const [addStaffModal, setAddStaffModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showActivateDeactivate, setShowActivateDeactivate] = useState(false);
  const [userId, setUserId] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [activate, setActivate] = useState(false);

  var userRole = user?.role;
  var staffAccess = user?.access?.staff;
  const column = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Contact",
      dataIndex: "contact_no",
      key: "contact_no",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Status",
      dataIndex: "is_deactivated",
      key: "is_deactivated",
      render: (value) => {
        return (
          <Tag
            className="flex items-center justify-center"
            color={!value ? "success" : "error"}
          >
            {value ? "Disabled" : "Active"}
          </Tag>
        );
      },
    },
    {
      title: "Last Login On",
      dataIndex: "last_login_at",
      key: "last_login_at",
    },
    {
      key: "actions",
      width: 100,
      render: (text, record) => (
        <TableActions
          userActive={!record.is_deactivated}
          showUserDisable={userRole === "Admin" || staffAccess?.delete}
          showUserEnable={userRole === "Admin" || staffAccess?.delete}
          showEdit={userRole === "Admin" || staffAccess?.edit}
          onClickEdit={(e) => {
            e.stopPropagation();
            setUpdateId(record.id);
            setAddStaffModal(true);
          }}
          onClickDisable={(e) => {
            e.stopPropagation();
            setUserId(record);
            setActivate(false);
            setShowActivateDeactivate(true);
          }}
          onClickEnable={(e) => {
            e.stopPropagation();
            setUserId(record);
            setActivate(true);
            setShowActivateDeactivate(true);
          }}
        />
      ),
    },
  ];
  const fetchStaffs = () => {
    startLoading();
    listAllStaff()
      .then((res) => {
        setTableData(res.data);
      })
      .catch((err) => console.log("Error on fetching Staffs", err))
      .finally(() => stopLoading());
  };
  useEffect(() => {
    fetchStaffs();
    setRefetch(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch]);

  const handleAddStaff = (values) => {
    startLoading();
    createStaff(values)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "New Staff Added Successfully",
        });
        setAddStaffModal(false);
        setRefetch(true);
        formRef.current.resetFields();
      })
      .finally(() => {
        stopLoading();
      });
  };
  const handleDeactivateStaff = () => {
    disableStaff(userId.id)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Staff Disabled Successfully ",
        });
        setRefetch(true);
      })
      .finally(() => {
        setUserId(null);
        setActivate(null);
        setShowActivateDeactivate(false);
      });
  };
  const handleActivateStaff = () => {
    enableStaff(userId.id)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Staff Activated Successfully ",
        });
        setRefetch(true);
      })
      .finally(() => {
        setUserId(null);
        setActivate(false);
        setShowActivateDeactivate(false);
      });
  };
  return (
    <div>
      <StyledContentCard title={"Staffs"}>
        <div className="flex float-right mb-2">
          {(userRole === "Admin" || staffAccess?.create) && (
            <StyledButton
              icon={<AiOutlinePlusSquare size={20} />}
              iconPosition="start"
              onClick={() => {
                setUpdateId(null);
                setAddStaffModal(true);
              }}
            >
              Staff
            </StyledButton>
          )}
        </div>
        {addStaffModal && (
          <StaffCreationModal
            showCreationModal={addStaffModal}
            setShowCreationModal={setAddStaffModal}
            onSubmit={handleAddStaff}
            formRef={formRef}
            updateId={updateId}
            setUpdate={setUpdateId}
            setRefetch={setRefetch}
          />
        )}
        {showActivateDeactivate && (
          <DisableEnableModal
            showModal={showActivateDeactivate}
            modalTitle={activate ? "Activate User" : "Deactivate User?"}
            title={userId.name}
            activate={activate}
            onCancel={() => {
              setUserId(null);
              setShowActivateDeactivate(false);
              setActivate(false);
            }}
            onsubmit={activate ? handleActivateStaff : handleDeactivateStaff}
          />
        )}
        <CustomTable
          data={tableData}
          columns={column}
          rowKey="id"
          onRow={(record) => {
            return {
              onClick: () => {
                navigate(`/staff/${record.id}`);
              },
              className: "clickable",
            };
          }}
        />
      </StyledContentCard>
    </div>
  );
}

export default StaffPage;
